import React from 'react';

import {
  useTable,
  useBlockLayout,
  useFilters,
  useGroupBy,
  useSortBy,
  useExpanded,
  TableState,
} from 'react-table';

import Header from './Header';
import Rows from './Rows';
import { TableWrapper } from './Table.styled';
import { useMaterialsTableContext } from '../MaterialsTableContext';
// import styled, { createGlobalStyle } from 'styled-components';
// import loadNamespaces from 'next-translate/loadNamespaces';
// import fetch from '../../data/restApi/fetchApi';
// import { usePruslation } from '../../app/utils/hooks';
// import IntlText from '../../app/components/IntlText';
// import { SimpleTooltip } from '../../app/components/layout';
// import { Button } from '../../app/components/layout/Button';
// import { Tag } from '../../app/components/TagBadge';
// import useBreakpoint from '@/hooks/useBreakpoint';
// import { throttle, urlBuilder, getReferer } from '../../app/utils/helpers';
// import { useMediaQuery, useModal } from '../../app/utils/hooks';
// import messages from '../messages';

/**
 * @todo translate
 * @todo upgrade to latest @tanstack/react-table
 */
export default function Table({ exporting = false, columns }) {
  // const { t } = usePruslation();

  const { filteredTableData, clearActiveColumn } = useMaterialsTableContext();

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    // state: { groupBy, expanded },
  } = useTable(
    {
      columns,
      data: filteredTableData,
      initialState: { groupBy: ['material'] } as Partial<TableState<object>>,
    },
    useBlockLayout,
    useFilters,
    useGroupBy,
    useSortBy,
    useExpanded
    // useSticky
  );

  return (
    <TableWrapper
      // forceView={forceDesktopView}
      onMouseLeave={() => clearActiveColumn()}
      $exporting={exporting}
    >
      <div {...getTableProps()} className="table sticky">
        <Header headerGroups={headerGroups} />
        <Rows
          rows={rows}
          getTableBodyProps={getTableBodyProps}
          prepareRow={prepareRow}
        />
      </div>
    </TableWrapper>
  );
}
